import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { ctrlButton } from '../ui.js'

const type = 'EA_CALLPROPS'
const onCallProps = object(listener, {
  type,
  passive,
  task: (
    element,
    event
  ) => {
    const { camera } = event.detail
    const cameraButton = ctrlButton('camera')
    const pauseButton = ctrlButton('pause')
    if (camera) {
      cameraButton.classList.add(utilities.modifiers.display.none)
      pauseButton.classList.remove(utilities.modifiers.display.none)
    } else {
      cameraButton.classList.remove(utilities.modifiers.display.none)
      pauseButton.classList.add(utilities.modifiers.display.none)
    }
  }
})

export default element => {
  onCallProps.listen(element)
}
